import {
    GET_DASHBOARD_DATA
} from "../types";
import axios from "../../axios";
// import Swal from 'sweetalert2';
import { setAlert } from "./alert";


export const getDashboardData = () => async (dispatch) => {
    try {
        const res = await axios.get("dashboard/summary");

        if (res.data.code === 1) {
            dispatch({ type: GET_DASHBOARD_DATA, payload: res.data.data });
            // Swal.fire({
            //     title: 'Success!',
            //     text: res.data.message,
            //     icon: 'success',
            // });
            // dispatch(setAlert(res.data.message, 'success'));
        } else {
            dispatch(setAlert(res.data.message, "warning"));
        }
    } catch (err) {
        dispatch(setAlert(err.message, 'danger'));
    }
};
